// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3RRBI","approved":"Status_approved__1lit8","rejected":"Status_rejected__2nKsn","expired":"Status_expired__1NNSH","label":"Status_label__4Kkbo"};